export enum WINDING{
	ODD = 0,
	NONZERO = 1,
	POSITIVE = 2,
	NEGATIVE = 3,
	ABS_GEQ_TWO = 4,
};

export enum ELEMENT {
	POLYGONS = 0,
	CONNECTED_POLYGONS = 1,
	BOUNDARY_CONTOURS = 2,
};
